/**
 * Used in replacement of AxiosResponse,
 * this way if something is using response.data, it still works
 * the rest of response is at response.response
 */
export class FetchResponse<T = unknown> {
    public constructor(public response: Response, public data: T) {}
}
